export const USER_KEY = "user-key";

export const saveUser = (user) => localStorage.setItem(USER_KEY, JSON.stringify(user));

export const clearUser = () => localStorage.removeItem(USER_KEY);

export const getUserToken = () => {
    return new Promise((resolve, reject) => {
        const userObj = JSON.parse(localStorage.getItem(USER_KEY));
        if (userObj && userObj.token) {
            resolve(userObj.token);
        } else {
            resolve('');
        }
    })
};

export const getUser = () => {
    return new Promise((resolve, reject) => {
        resolve(JSON.parse(localStorage.getItem(USER_KEY)));
    });
};

export const getUserSync = () => JSON.parse(localStorage.getItem(USER_KEY));



// WEBPACK FOOTER //
// ./src/utils/auth.js